import React, { useEffect, useState } from "react";
import {
  Table,
  Tooltip,
  Button,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  Image,
  Upload,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import qs from "qs";
import axios from "axios";
import { SERVER_ADDRESS } from "../../../Config/Config";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

const Categorylist = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ismodalOpen, setIsmodalOpen] = useState(false);
  const [record, setRecord] = useState(null);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [imageBase64, setImageBase64] = useState(null);
  const [isImageEdited, setIsImageEdited] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const handleSearch = (e) => {
    const searchValue = e.toLowerCase();
    // setSearchTerm(searchValue);
    setFilteredData(
      data.filter((item) =>
        item.category_name.toLowerCase().includes(searchValue)
      )
    );
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImageChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const base64 = await getBase64(newFileList[0].originFileObj);
      setImageBase64(base64);
      setIsImageEdited(true);
    } else {
      setImageBase64(null);
      setIsImageEdited(true);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src && file.originFileObj) {
      src = await getBase64(file.originFileObj);
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, data]);

  const columns = [
    {
      title: "Id",
      dataIndex: "category_id",
      sorter: "true",
      sorter: (a, b) => a.category_id - b.category_id,
      width: "10%",
      key: "category_id",
    },
    {
      title: "Category Name",
      dataIndex: "category_name",
      sorter: (a, b) => a.category_name.localeCompare(b.category_name),
      width: "10%",
      key: "category_name",
    },
    {
      title: "Search Key",
      dataIndex: "category_search_key",
      sorter: "true",
      width: "10%",
      key: "category_search_key",
      render: (text) => {
        const displaysearchkey =
          text.length > 15 ? `${text.slice(0, 15)}...` : text;
        return text.length > 15 ? (
          <Tooltip title={text}>
            <span>{displaysearchkey}</span>
          </Tooltip>
        ) : (
          <span>{text}</span>
        );
      },
    },
    {
      title: "Category Image",
      width: "20%",
      key: "category_image",
      render: (_, record) => (
        <>
          {record.category_image ? (
            <Image src={record.category_image} />
          ) : (
            <Image src="https://placehold.co/600x400" />
          )}
        </>
      ),
    },
    {
      title: "Options",
      width: "10%",
      key: "option",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Tooltip title="Edit">
            <Button
              type="primary"
              onClick={() => handleEdit(record)}
              icon={<EditOutlined />}
            ></Button>
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              placement="bottom"
              title="Delete Category"
              description="Are you sure to delete category ?"
              onConfirm={() => handleDelete(record.category_id)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger icon={<DeleteOutlined />}></Button>
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleEdit = (record) => {
    setRecord(record);
    setIsmodalOpen(true);

    form.setFieldsValue({
      category_name: record.category_name,
      category_search_key: record.category_search_key,
    });

    if (record.category_image) {
      setFileList([
        {
          uid: "-1",
          name: "current_image.png",
          status: "done",
          url: record.category_image,
        },
      ]);
      setImageBase64(record.category_image);
    }
  };

  const handleCancel = () => {
    setIsmodalOpen(false);
    setRecord(null);
    setFileList([]);
    setImageBase64(null);
    setIsImageEdited(false);
  };
  const handleDelete = async (id) => {
    try {
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/delete-category/${id}`
      );
      if (response.status === 200) {
        fetchCategories();
        message.success({
          content: "Category deleted successfully",
          duration: 2,
        });
      } else {
        message.error({ content: "Failed to delete cateogory", duration: 2 });
      }
    } catch (error) {
      message.error({ content: "Internal Server error", duration: 2 });
    }
  };

  const fetchCategories = async (pagination) => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_ADDRESS}/api/category-list`);
      setData(response.data);
      setFilteredData(response.data);
      setLoading(false);
    } catch (error) {
      message.error({ content: "Error on fetching data", duration: 2 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleTablechange = () => {
    fetchCategories();
  };

  const handleUpdate = async (values) => {
    try {
      const payload = {
        ...values,
        category_image: isImageEdited ? imageBase64 : record.category_image,
        isImageEdited,
      };

      const response = await axios.post(
        `${SERVER_ADDRESS}/api/update-category/${record.category_id}`,
        payload
      );

      if (response.status === 200) {
        message.success({
          content: "Category updated successfully",
          duration: 2,
        });
        setIsmodalOpen(false);
        setRecord(null);
        setFileList([]);
        setImageBase64(null);
        setIsImageEdited(false);
        fetchCategories();
      } else {
        message.error({ content: "Failed to update category", duration: 2 });
      }
    } catch (error) {
      console.log(error);
      message.error({ content: "Internal server error", duration: 2 });
    }
  };

  return (
    <div
      style={{
        marginTop: "4rem",
      }}
    >
      <Input
        placeholder={"Search by category name"}
        prefix={<SearchOutlined />}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "1rem", width: "23%" }}
      />
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="category_id"
        loading={loading}
        onChange={handleTablechange}
      ></Table>
      <Modal
        open={ismodalOpen}
        onCancel={handleCancel}
        footer={null}
        title="Edit Category"
      >
        <Form
          {...formItemLayout}
          form={form}
          style={{
            backgroundColor: "white",
            width: "30rem",
            marginTop: "2rem",
            padding: "2rem",
          }}
          onFinish={handleUpdate}
        >
          <Form.Item
            label="Category Name"
            name="category_name"
            rules={[
              { required: true, message: "Enter the category name" },
              {
                validator: (_, value) => {
                  if (value && value.trim().toLowerCase() === "image") {
                    return Promise.reject("Category name cannot be 'image'");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Enter Category Name" />
          </Form.Item>

          <Form.Item
            label="Search Key"
            name="category_search_key"
            rules={[
              { required: true, message: "Enter the category search key" },
            ]}
          >
            <Input placeholder="Enter search key" />
          </Form.Item>

          <Form.Item label="Category Image" name="category_image">
            <Upload
              listType="picture-card"
              fileList={fileList}
              onChange={handleImageChange}
              onPreview={onPreview}
              showUploadList={{ showPreviewIcon: false }}
              beforeUpload={() => false}
            >
              {fileList.length >= 1 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 10, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Categorylist;
